import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: [],
	loading: false,
	allHasReads: true,
	pagination: {
		page: 1,
		perPage: 10,
		totalItems: 0,
		totalPage: 0,
	},
};

const notificationSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setNotificationsData: (state, action) => {
			state.data = Array.isArray(action.payload.data) ? action.payload.data : [];
			state.pagination.totalItems = action.payload.total || 0;
			state.pagination.page = action.payload.current_page || 1;
			state.pagination.perPage = action.payload.per_page || 10;
			state.pagination.totalPage = Math.ceil(action.payload.total / action.payload.per_page);
		},

		setLoadingNotifications: (state, action) => {
			state.loading = action.payload;
		},
		setClearNotifications: (state) => {
			state.data = [];
		},
		updateNotification: (state, action) => {
			if (!Array.isArray(state.data)) {
				console.error("state.data is not an array! Resetting to []", state.data);
				state.data = []; // Reset to an empty array
			}

			state.data = state.data.map((notif) =>
				notif.notification_id === action.payload.notification_id
					? { ...notif, has_read: action.payload.has_read }
					: notif,
			);
		},
		setAllHasReads: (state, action) => {
			state.allHasReads = action.payload;
		},
	},
});

export const {
	setNotificationsData,
	setLoadingNotifications,
	setClearNotifications,
	updateNotification,
	setAllHasReads,
} = notificationSlice.actions;

export default notificationSlice.reducer;
